import React, { useState } from "react";
import "./category.css";
import LawyerEmoji from "./assets/lawyerEmoji.png";
import SupportEmoji from "./assets/supportEmoji.png";
import BackIcon from "./assets/backIcon.png";
import { useNavigate } from "react-router-dom";
import {
  resetOnboardingInfo,
  updateOnboardingInfo,
} from "../../redux/attorneyOnboardingSlice";
import { useDispatch, useSelector } from "react-redux";
import StepFooter from "./stepFooter";

function Category() {
  const [selectedProfile, setSelectedProfile] = useState("");

  const userId = useSelector(
    (state) => state.attorneyData.attorneyData?.user_id
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goBackToProfessionals = () => {
    dispatch(resetOnboardingInfo());
    navigate(`/attorney/${userId}/home`);
  };

  const handleSelect = (type) => {
    setSelectedProfile(type);
  };

  const handleNext = () => {
    dispatch(updateOnboardingInfo({ selectedProfile: selectedProfile }));
  };

  // Disable the footer if no profile type is selected
  const isFooterDisabled = !selectedProfile;

  return (
    <div className="category-select-profile-type-container">
      <div className="category-profile-types">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="category-breadcrumb" onClick={goBackToProfessionals}>
            <img src={BackIcon} style={{ width: "24px", height: "24px" }} />
            <a className="category-back-link">Back to professionals</a>
          </div>

          <h1 className="category-page-title">Select a profile type</h1>
          <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            {/* Legal Provider Card */}
            <div
              className={`category-profile-card ${
                selectedProfile === "legal" ? "active" : ""
              }`}
              onClick={() => handleSelect("legal")}
            >
              <img
                src={LawyerEmoji}
                style={{ width: "48px", height: "48px", marginBottom: "1rem" }}
                aria-label="legal"
              />
              <h2 className="category-profile-card-title">Legal Provider</h2>
              <p className="category-profile-card-description">
                Clients can schedule a consultation with you directly
              </p>
            </div>

            {/* Practice Support Specialist Card */}
            <div
              className={`category-profile-card ${
                selectedProfile === "support" ? "active" : ""
              }`}
              onClick={() => handleSelect("support")}
            >
              <img
                src={SupportEmoji}
                style={{ width: "36px", height: "36px", marginBottom: "1rem" }}
                aria-label="support"
              />
              <h2 className="category-profile-card-title">
                Practice Support Specialist
              </h2>
              <p className="category-profile-card-description">
                Supports legal operations and account management
              </p>
            </div>
          </div>
        </div>
      </div>
      <StepFooter
        currentStep={1}
        totalSteps={9}
        location="/attorney/setup/bar-details"
        onNext={handleNext}
        disabled={isFooterDisabled} // Disable Continue button if no profile type is selected
      />
    </div>
  );
}

export default Category;
